import type { FaireProductEntity } from "../../entity_types/product";

export const p_mquej8ekdg: FaireProductEntity = {
  token: "p_mquej8ekdg",
  type: "product",
  name: "Wood Leaf Bowl, Teak Leaf Bowl, Leaf Bowl, Handcrafted Leaf Bowl,",
  brandName: "baligood",
  imageUrl:
    "https://cdn.faire.com/fastly/bdb4392b4f527630c86449ac6d920486cfd0dd02c6d2e48b0dc46442d29c3b1f.jpeg",
  priceDollars: 58.5,
  description: "",
  categoryTokens: ["cat_accessories"],
  tags: [],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T13:23:30Z",
    importedBy: "retailerThemesSeed-migration",
  },
  freeShipping: true,
  brandAvatarUrl:
    "https://cdn.faire.com/fastly/982aab2be0ae6f9b2e236137781e9f39b9bdc30133ee722e1a25eaf45e6fa6b1.jpeg",
  weight: 0.5,
  dimensions: {
    width: 4,
    height: 4,
    depth: 2,
  },
  inStock: true,
};
